import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { completeLogin, resumeAfterSilentLoginFailure } from '../lib/auth.js';

export default function Callback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [error, setError] = useState(null);
  // The sign-in transaction is one-shot; never consume it twice (StrictMode
  // double-invokes effects in development).
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const state = params.get('state');
    const idpError = params.get('error');
    if (idpError) {
      // A silent (prompt=none) attempt with no hosted UI session: go back to
      // the page, which now takes its interactive sign-in path.
      const resumeAt = resumeAfterSilentLoginFailure({ error: idpError, state });
      if (resumeAt) {
        nav(resumeAt, { replace: true });
        return;
      }
      setError(params.get('error_description') || idpError);
      return;
    }

    completeLogin({ code: params.get('code'), state })
      .then((returnTo) => nav(returnTo, { replace: true }))
      .catch((e) => setError(e.message || 'Sign-in failed.'));
  }, [params, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      {error ? (
        <div className="card max-w-md">
          <h2>Sign-in error</h2>
          <p className="text-sm text-slate-600 mt-2">{error}</p>
          <a href="/login" className="btn-primary mt-4">Try again</a>
        </div>
      ) : (
        <p className="text-slate-500">Completing sign-in…</p>
      )}
    </div>
  );
}
